import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Page,
  Link,
  Icon,
  Button,
  Input,
  f7,
  ListItem,
  List,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { f7router } from "framework7-react";
import "./DatePicker.css";
import debounce from "lodash.debounce";

const CartPage = ({ f7route }) => {
  const { id } = f7route.params;
  const [data, setData] = useState({});
  const [count, setCount] = useState(1);
  const [menuAmount, setMenuAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [cartRestId, setCartRestId] = useState(0);
  const [stateData, setStateData] = useState([]);
  const [restData, setRestData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const currentDate = new Date().toISOString().slice(0, 16);
  var amount = menuAmount;
  const [selectedDate, setSelectedDate] = useState(null);
  const [auth, setAuth] = useState(localStorage.getItem("auth"));
  const [formData, setFormData] = useState({
    cust_id: localStorage.getItem("id"),
    order_status: 1,
    event_status: 2,
    rest_id: id,
  });
  
  const [selectedRadio, setSelectedRadio] = useState("2");
  const [addressSuggestions, setAddressSuggestions] = useState([]);

  useEffect(() => {
    const existingData =
      JSON.parse(localStorage.getItem("orderCartItems")) || [];

    setSelectedRadio(
      existingData?.formData?.selectedRadio
        ? existingData?.formData?.selectedRadio
        : "2"
    );

    setSelectedDate(
      existingData?.formData?.selectedDate
        ? new Date(existingData?.formData?.selectedDate)
        : null
    );
    setFormData({
      ...formData,
      event_name: existingData?.formData?.event_name,
      event_adult_size: existingData?.formData?.event_adult_size,
      event_kids_size: existingData?.formData?.event_kids_size,
      add_lin_1: existingData?.formData?.add_lin_1,
      add_lin_2: existingData?.formData?.add_lin_2,
      city: existingData?.formData?.city,
      state: existingData?.formData?.state,
      zip_code: existingData?.formData?.zip_code,
      event_note: existingData?.formData?.event_note,
    });
  }, []);

  useEffect(() => {
    const existingData =
      JSON.parse(localStorage.getItem("orderCartItems")) || [];
    const {
      cust_id,
      order_status,
      event_status,
      rest_id,
      ...filteredFormData
    } = formData;

    const updatedData = {
      ...existingData,
      formData: {
        ...filteredFormData,
        selectedDate,
        selectedRadio,
      },
    };

    localStorage.setItem("orderCartItems", JSON.stringify(updatedData));
  }, [formData, selectedDate, selectedRadio]);

  useEffect(() => {
    axios
      .get(API_BASE_URL + "state", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setStateData(response.data))
      .catch((error) => console.log(error));
    axios
      .get(API_BASE_URL + "restaurants/id/" + id, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setRestData(response.data);
      })
      .catch((error) => console.log(error));

    const storedOrderDetails = localStorage.getItem("orderCartItems");

    if (storedOrderDetails) {
      const cartInfo = JSON.parse(storedOrderDetails)?.items || [];

      const isRestIdMatched = cartInfo.some((item) => item?.rest_id == id);

      if (isRestIdMatched && cartInfo.length > 0) {
        setData(cartInfo);
      }
    }
  }, []);

  const handleBackAndReload = () => {
    f7.views.main.router.navigate("/main/", {
      reloadCurrent: true,
      back: true,
    });
  };
  useEffect(() => {
    const id = localStorage.getItem("id");
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: "Basic " + API_AUTH,
    };
    axios
      .post(API_BASE_URL + "custauth", { id, token }, { headers })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "success") {
          localStorage.setItem("auth", true);
          setAuth(true);

          // Introduce a delay of 1000 milliseconds (1 second) after API call success
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   f7.views.main.router.navigate('/main/');
          // }, 1000);
        } else {
          localStorage.setItem("auth", false);
          setAuth(false);
          // // Introduce a delay of 1000 milliseconds (1 second) after API call failure
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   // f7.views.main.router.navigate('/login/');
          // }, 1000);
        }
      })
      .catch((error) => {
        setAuth(false);
        // Introduce a delay of 1000 milliseconds (1 second) after API call error
        // setTimeout(() => {
        //   setIsLoading(false); // API call is complete even in case of an error
        //   console.log(error);
        //   // f7.views.main.router.navigate('/login/');
        // }, 1000);
      });
  });
  const handleIncrement = (index) => {
    const updatedData = [...data];
    updatedData[index].qty += 1;
    updatedData[index].total_amount =
      updatedData[index].qty * updatedData[index].menu_amount;
    setData(updatedData);
    setMenuAmount(menuAmount);
    const existingData =
      JSON.parse(localStorage.getItem("orderCartItems")) || {};

    // Update the items part while keeping the other parts intact
    const updatedArray = {
      ...existingData, // Keep the existing form data (selectedDate, selectedRadio, etc.)
      items: updatedData, // Update only the items array
    };

    localStorage.setItem("orderCartItems", JSON.stringify(updatedArray));
  };

  const handleDecrement = (index) => {
    const updatedData = [...data];
    if (updatedData[index].qty > 0) {
      updatedData[index].qty -= 1;
      updatedData[index].total_amount =
        updatedData[index].qty * updatedData[index].menu_amount;
      setData(updatedData);
      const existingData =
        JSON.parse(localStorage.getItem("orderCartItems")) || {};

      // Update the items part while keeping the other parts intact
      const updatedArray = {
        ...existingData,
        items: updatedData,
      };

      localStorage.setItem("orderCartItems", JSON.stringify(updatedArray));
    }
  };
  const deleteItem = (index) => {
    const cart = JSON.parse(localStorage.getItem("orderCartItems"))?.items;
    if (index >= 0 && index < cart.length) {
      const updatedArray = cart.slice(0, index).concat(cart.slice(index + 1));
      const existingData =
        JSON.parse(localStorage.getItem("orderCartItems")) || {};

      // Update the items part while keeping the other parts intact
      const updatedArrayString = {
        ...existingData,
        items: updatedArray,
      };

      localStorage.setItem(
        "orderCartItems",
        JSON.stringify(updatedArrayString)
      );
      setData(updatedArray);
    }
  };

  const handleDelete = (index) => {
    const updatedProduct = [...data];
    updatedProduct.splice(index, 1);
    setData(updatedProduct);
    localStorage.setItem("orderCartItems", JSON.stringify(updatedProduct));
    setFormData({
      ...formData,
      items: JSON.parse(localStorage.getItem("orderCartItems")),
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleRadioChange = (value) => {
    setSelectedRadio(value);
    setFormData({
      ...formData,
      add_lin_1: undefined,
      add_lin_2: undefined,
      city: undefined,
      state: undefined,
      zip_code: undefined,
      event_note: undefined,
    });
  };

  const handleAddressChange = (event) => {
    const value = event.target.value;
    setFormData({
      ...formData,
      add_lin_1: value,
    });
    // setAddressSearchTerm(value);
    debouncedFetchAddresses(value);
  };

  const debouncedFetchAddresses = useCallback(
    debounce((value) => {
      if (value.length > 0) {
        axios
          .get(API_BASE_URL + `googleapiaddresssearch/?input=${value}`, {
            headers: {
              Authorization: "Basic " + API_AUTH,
            },
          })
          .then((response) => {
            // const formattedAddress = response?.data?.data?.map(
            //   (add) => add?.formatted_address
            // );

            setAddressSuggestions(response?.data?.data?.predictions);
          })
          .catch((error) => {
            console.log(error);
            setAddressSuggestions([]);
          });
      } else {
        setAddressSuggestions([]);
      }
    }, 500),
    []
  );

  const handleAddressItemClick = async (item) => {
    setAddressSuggestions("");
    // setFormData({
    //   ...formData,
    //   add_lin_1: item.formatted_address,
    // });
    // setAddressSearchTerm(item.formatted_address);
    // setAddressSuggestions("");
    await axios
      .get(API_BASE_URL + `googleapiplaceidsearch/?place_id=${item.place_id}`, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        let formattedData = JSON.parse(response.data.data);

        const addressComponents = formattedData?.address_components || [];
        const updatedFormData = {
          add_lin_1: formattedData?.formatted_address1,
          add_lin_2: "",
          city: "",
          state: "",
          zip_code: "",
        };
        // setFormData({
        //   ...formData,
        //   add_lin_1: item.formatted_address,
        // });
        addressComponents.forEach((component) => {
          switch (component.types[0]) {
            case "locality":
              updatedFormData.city = component.long_name;
              break;
            case "sublocality_level_1":
              updatedFormData.add_lin_2 = component.long_name;
              break;
            case "postal_code":
              updatedFormData.zip_code = component.long_name;
              break;
            case "administrative_area_level_1":
              const matchingState = stateData.find(
                (item) => item.name === component.long_name
              );
              if (matchingState) {
                updatedFormData.state = matchingState.id;
              }
              break;
            default:
              break;
          }
        });

        setFormData({
          ...formData,
          ...updatedFormData,
        });
      })
      .catch((error) => {
        console.log(error);
        setAddressSuggestions([]);
      });
  };
  const inputRef = useRef(null);
  const suggestionsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setAddressSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef, suggestionsRef]);

  const submitOrder = (e) => {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true); // Disable the button
    const storedOrderDetails = localStorage.getItem("orderCartItems");
    let items;
    const cartInfo = JSON.parse(storedOrderDetails)?.items;

    const isRestIdMatched = cartInfo.some((item) => item?.rest_id == id);
    if (isRestIdMatched && cartInfo.length > 0) {
      items = JSON.parse(localStorage?.getItem("orderCartItems"))?.items?.map(
        (item) => {
          const { menu_item_picture, serves, ...rest } = item;
          return rest;
        }
      );
    } else {
      items = {};
    }
    const orderData = {
      ...formData,
      items: items,
      grand_total: JSON.parse(
        localStorage?.getItem("orderCartItems")
      )?.items?.reduce((acc, item) => acc + item.total_amount, 0),
      sub_total: JSON.parse(
        localStorage?.getItem("orderCartItems")
      )?.items?.reduce((acc, item) => acc + item.total_amount, 0),
      event_date: selectedDate,
      tax: restData.map((item) => item.state_tax)[0],
      delivery_type: selectedRadio,
    };

    axios
      .post(API_BASE_URL + "orders", orderData, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        console.log(response.data);
        localStorage.removeItem("orderCartItems");

        // f7.views.main.router.navigate({
        //   name: "payment",
        //   params: {
        //     id: response.data.order_id,
        //   },
        // });
        f7.views.main.router.navigate("/main/", {
          reloadCurrent: true,
          back: true,
        });
        f7.toast
          .create({
            text: "Event Details Information added..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 3000,
          })
          .open();
      })
      .catch((error) =>
        f7.toast
          .create({
            text: "something went wrong..!",
            position: "top",
            cssClass: "bg-color-red",
            closeTimeout: 3000,
          })
          .open()
      )
      .finally(() => {
        setIsSubmitting(false); // Re-enable the button after registration attempt
      });
  };
  const redLogin = () => {
    const serializedData = JSON.stringify(formData);
    // Store the data in local storage under the key 'myKey'
    localStorage.setItem("formData", serializedData);
    f7.views.main.router.navigate("/login/");
  };
  // console.log(data);

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   axios.put(API_BASE_URL + 'restaurants/id/1', data, {
  //     headers: {
  //       'Authorization': 'Basic ' + API_AUTH
  //     }
  //   })
  //     .then(response => f7.toast.create({
  //       text: 'Profile Updated..!',
  //       position: 'top',
  //       cssClass: 'bg-color-teal',
  //       closeTimeout: 3000
  //     }).open())
  //     .catch(error => f7.dialog.alert('Error updating data!'));
  // }

  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 2);

  const minBidDate = new Date();
  minBidDate.setDate(minDate.getDate() + 2);

  return (
    <Page className="bg-white">
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/> */}
      <div className="container container-table  ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link onClick={handleBackAndReload} href="#" back reloadAll>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Cart</h2>
              </div>
            </div>
          </header>

          {/* <header className="section-t-space">
            <div className="custom-container p-0">
              <div className="header-panel">
                <Button onClick={handleBackAndReload}><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Button>
                <h2>Cart</h2>
              </div>
            </div>
          </header> */}
          <section className="profile-form mt-3">
            <div className="custom-container p-0 ">
              <div class="title">
                <h3 class="mt-0">Event Details</h3>
              </div>
              <form
                className="auth-form address-form mt-3"
                onSubmit={submitOrder}
              >
                <div className="form-group">
                  <label className="form-label fw-semibold">
                    Name of the Event
                  </label>
                  <div className="form-input mb-4">
                    <Input
                      type="text"
                      className="form-control"
                      required
                      validate
                      pattern=".{3,}"
                      errorMessage="Please enter name of the event."
                      placeholder="Name of the Event"
                      name="event_name"
                      value={formData.event_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label fw-semibold">
                    Event Date and time
                  </label>
                  <div className="form-input mb-4">
                    <DatePicker
                      selected={selectedDate}
                      onChange={(date) => setSelectedDate(date)}
                      showTimeSelect
                      timeFormat="h:mm aa"
                      timeIntervals={15}
                      dateFormat="MM-dd-yyyy h:mm aa"
                      placeholderText="Select event date and time"
                      className="form-control col-md-12"
                      minDate={minDate}
                    />
                  </div>
                </div>

                {/* <div className="form-group">
                  <label className="form-label fw-semibold">Date and time of the Event</label>
                  <div className="form-input mb-4">
                    <Input type="datetime-local" className="form-control" min={currentDate} required validate errorMessage="Please select date of event." placeholder="Event Date and time" name="event_date" value={formData.event_date} onChange={handleChange}/>
                  </div>
                </div> */}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="form-group" style={{ width: "49%" }}>
                    <label className="form-label fw-semibold">
                      No of Adults
                    </label>
                    <div className="form-input mb-4">
                      <Input
                        type="text"
                        required
                        validate
                        pattern="[0-9\s]{1,4}"
                        errorMessage="Please enter no of adults."
                        className="form-control"
                        placeholder="No of Adults"
                        name="event_adult_size"
                        value={formData.event_adult_size}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group" style={{ width: "49%" }}>
                    <label className="form-label fw-semibold">No of Kids</label>
                    <div className="form-input mb-4">
                      <Input
                        type="text"
                        validate
                        pattern="[0-9\s]{1,4}"
                        errorMessage="Please enter no of kids."
                        className="form-control"
                        placeholder="No of Kids"
                        name="event_kids_size"
                        value={formData.event_kids_size}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <List style={{ marginTop: "10px" }}>
                    {/* <label className="form-label fw-semibold">
                      Deliver type
                    </label> */}
                    <ListItem
                      radio
                      value="1"
                      name="demo-radio"
                      title="Delivery"
                      checked={selectedRadio == "1"}
                      onChange={() => handleRadioChange("1")}
                    ></ListItem>
                    <ListItem
                      radio
                      value="2"
                      name="demo-radio"
                      title="Pickup"
                      checked={selectedRadio == "2"}
                      required
                      validate
                      onChange={() => handleRadioChange("2")}
                    ></ListItem>
                  </List>
                </div>
                {selectedRadio !== "2" && (
                  <>
                    <h4 className="mb-3 text-3 fw-bold">Event Address</h4>
                    <div className="form-group">
                      <label className="form-label fw-semibold">
                        Address 1
                      </label>
                      <div className="form-input mb-2">
                        <input
                          ref={inputRef}
                          // pattern=".{5,}"
                          errorMessage="Please enter event address."
                          className="form-control"
                          placeholder="Event Address"
                          name="add_lin_1"
                          value={formData.add_lin_1}
                          // value={addressSearchTerm}
                          autoComplete="off"
                          onChange={handleAddressChange}
                        />
                      </div>

                      <div
                        className="form-input mb-4"
                        style={{ width: "100%" }}
                      >
                        {addressSuggestions.length > 0 &&
                        formData.add_lin_1 !== "" ? (
                          <ul
                            ref={suggestionsRef}
                            className="auto-complete-list"
                            style={{
                              width: "93%",
                              zIndex: 99,
                              minHeight: "auto",
                              maxHeight: "250px",
                              backgroundColor: "white",
                              overflow: "scroll",
                              overflowX: "hidden",
                            }}
                          >
                            {addressSuggestions.map((item) => (
                              <li
                                key={item.id}
                                onClick={() => {
                                  handleAddressItemClick(item);
                                  // setFormData({
                                  //   ...formData,
                                  //   add_lin_1: item.formatted_address,
                                  // });
                                }}
                                style={{ border: "1px solid #E5E7EB" }}
                              >
                                {item.description}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">
                        Address 2
                      </label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          // required
                          // validate
                          errorMessage="Please enter event second address."
                          className="form-control"
                          placeholder="Event Address"
                          name="add_lin_2"
                          value={formData.add_lin_2}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">City</label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          // required
                          // validate
                          // pattern="[a-zA-Z ]{2,}"
                          errorMessage="Please enter city."
                          className="form-control"
                          placeholder="City"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">State</label>
                      <div className="form-input mb-4">
                        <select
                          className="form-select form-control"
                          // required
                          // validate
                          errorMessage="Please select State"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                        >
                          <option value="0">Select State</option>
                          {stateData.map((item) => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">Zip Code</label>
                      <div className="form-input mb-4">
                        <Input
                          type="tel"
                          className="form-control"
                          // required
                          // validate
                          // pattern="[0-9]{5}"
                          placeholder="Enter Zip Code"
                          errorMessage="Please enter zip code."
                          name="zip_code"
                          value={formData.zip_code}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">
                        Additional Instructions
                      </label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          validate
                          // pattern=".{5,}"
                          errorMessage="Please enter event note."
                          className="form-control"
                          placeholder="Enter Additional Instructions"
                          name="event_note"
                          value={formData.event_note}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div class="title">
                  <h3 class="mt-0">Menu Details</h3>
                </div>
                <div className="auth-form address-form mt-0 mb-0"></div>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <div className="horizontal-product-box m-2">
                      <div className="product-img">
                        {item.menu_item_picture !== null &&
                        item.menu_item_picture !== undefined &&
                        item.menu_item_picture !== "" ? (
                          <img
                            className="img-fluid img"
                            src={`${IMG_URL}${item.menu_item_picture}`}
                            alt={item.menu_item_name}
                          />
                        ) : (
                          <img
                            className="img-fluid img"
                            style={{ height: "125px", width: "125px" }}
                            src={require("./../images/no-image.png")}
                            alt={item.menu_item_name}
                          />
                        )}
                      </div>
                      <div className="product-content">
                        <h5>{item.menu_name}</h5>
                        <div style={{ display: "flex" }}>
                          <h6>{item.menu_size_name} </h6>{" "}
                          <h6>({item.serves})</h6>
                        </div>
                        {/* <Stepper raised/> */}
                        <div></div>
                        <div className="plus-minus p-0">
                          <i className="ri-subtract-line sub" />
                          <Button onClick={() => handleDecrement(index)}>
                            <Icon
                              ios="material:remove"
                              aurora="material:remove"
                              md="material:remove"
                              size={14}
                            ></Icon>
                          </Button>
                          <Input
                            type="number"
                            value={item.qty}
                            min={1}
                            max={20}
                          />
                          <Button onClick={() => handleIncrement(index)}>
                            <Icon
                              ios="material:add"
                              aurora="material:add"
                              md="material:add"
                              size={14}
                            ></Icon>
                          </Button>
                          <i className="ri-add-line add" />
                        </div>
                        <a
                          type="button"
                          className="red-symbol"
                          onClick={() => deleteItem(index)}
                        >
                          <i class="fi fi-sr-cross-circle"></i>
                        </a>
                        {/* <img className="red-symbol" src="https://themes.pixelstrap.com/zomo-app/assets/images/svg/nonveg.svg" alt="non-veg" /> */}
                        <h3 className="product-price">
                          {" "}
                          $ {parseFloat(item.total_amount)?.toFixed(2)}
                        </h3>
                      </div>
                      {() => setCount(0)}
                    </div>
                  ))
                ) : (
                  <div className="custom-container">
                    <div className="empty-tab">
                      <h2>No Past Event Found!!</h2>
                      <h5 className="mt-3">You have currently no events.</h5>
                    </div>
                  </div>
                )}
                {/* {restData.map((item, index) => (
                      <label className="form-label fw-semibold">{item.rest_name}</label>
                    ))}
                  <div class="title">
                    <h3 class="mt-2">Restaurant Details</h3>
                  </div> */}

                {/* <div className='auth-form address-form mt-0 mb-0'></div>
                  <div className="form-group"> */}

                {/* <div className="form-input mb-4"><Input type="text" required validate pattern=".{5,}" errorMessage="Please enter event note." className="form-control" placeholder="Event Note" name="event_note" value={formData.event_note} onChange={handleChange}/></div> */}

                {/* </div>  */}
                <div className="custom-container p-0 ">
                  {/* <Button className="btn btn-success w-100 mb-2" large type="submit"  > Confirm Order</Button>  */}
                  {auth ? (
                    <Button
                      type="submit"
                      className="btn btn-success w-100 mb-2"
                      large
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "confirming..." : "Confirm Order"}
                    </Button>
                  ) : (
                    <Button
                      type="button"
                      onClick={redLogin}
                      className="btn btn-success w-100 mb-2"
                      large
                    >
                      Log in
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
};

export default CartPage;
